import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

const TextFieldGroup = ({field, value, label, error, type, onChange}) => {
  return (
    <div className={classnames("form-group", {"has-error": error})}>
      <label>{label}</label>
      <input
        onChange={onChange}
        value={value}
        type={type}
        name={field}
        className="form-control"
      />
      {error && <span>{error}</span>}
    </div>
  )
}

TextFieldGroup.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

TextFieldGroup.defaultProps = {
  type: "text"
}

export default TextFieldGroup



// WEBPACK FOOTER //
// ./src/components/decorators/TextFieldGroup.js